import "bootstrap/js/dist/carousel";
import "../../components/carousel-touch";

document.addEventListener("DOMContentLoaded", () => {
  const product_detail_images = document.getElementById(
    "product-detail-images"
  );
  const product_detail_images_buttons = product_detail_images.querySelectorAll(
    '.btn--gradient-border[data-bs-target="#product-detail-images"]'
  );
  const product_detail_images_dots = document.getElementById(
    "product-detail-images-dots"
  );
  const product_detail_images_dots_buttons =
    product_detail_images_dots.querySelectorAll("[data-bs-target]");
  product_detail_images.addEventListener("slid.bs.carousel", (e) => {
    const el = product_detail_images.querySelector('.product-slider__sub-content .btn--gradient-border--active');
    if (!el || !el.scrollIntoViewIfNeeded) {
      return;
    }
    el.scrollIntoViewIfNeeded();
  });
  product_detail_images.addEventListener("slide.bs.carousel", (e) => {
    product_detail_images_buttons.forEach(function (button, button_index) {
      if (button_index === e.to) {
        button.classList.add("btn--gradient-border--active");
      } else {
        button.classList.remove("btn--gradient-border--active");
      }
    });

    product_detail_images_dots_buttons.forEach(function (button, button_index) {
      if (button_index === e.to) {
        button.classList.remove("bg-alto");
        button.classList.add("bg-success");
      } else {
        button.classList.remove("bg-success");
        button.classList.add("bg-alto");
      }
    });

    //trigger video stop event
    const eventStopYoutubeVideo = new CustomEvent("stop-youtube-video");
    product_detail_images.dispatchEvent(eventStopYoutubeVideo);
    //trigger video event
    const /** @type HTMLDivElement */ relatedYoutubeTarget = e.relatedTarget;
    if (relatedYoutubeTarget.hasAttribute("data-youtube-embed")) {
      const eventYoutubeVideo = new CustomEvent("youtube-video", {
        bubbles: true,
        detail: { element: relatedYoutubeTarget },
      });
      product_detail_images.dispatchEvent(eventYoutubeVideo);
    }

    const eventStopVimeoVideo = new CustomEvent("stop-vimeo-video");
    product_detail_images.dispatchEvent(eventStopVimeoVideo);
    //trigger video event
    const /** @type HTMLDivElement */ relatedVimeoTarget = e.relatedTarget;
    if (relatedVimeoTarget.hasAttribute("data-vimeo-embed")) {
      const eventVimeoVideo = new CustomEvent("vimeo-video", {
        bubbles: true,
        detail: { element: relatedVimeoTarget },
      });
      product_detail_images.dispatchEvent(eventVimeoVideo);
    }


  });
});
